<template>
  <v-container fluid class="py-0">
    <v-row justify="center" v-if="lAction === 'view'">
      <v-col cols="12" sm="9" mx-auto>
        <v-card flat>
          <v-card-text class="pt-2 pb-0">
            <v-layout row wrap>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-alert color="info white--text mb-0">
                    Any changes made here will not affect site specific parameters. But, this list will help as a reference while adding new parameters to a facility.
                  </v-alert>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="9" mx-auto class="pa-0">
        <v-card flat>
          <v-card-text class="pt-2">
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp?watQual:watQualsm"
            :items="waterqualList"
            :mobile-breakpoint="0"
            hide-actions
            class="elevation-1">
            <template slot="item" slot-scope="props">
              <tr @click="prepareUpdate(props.item)">
                <td>{{ props.item.water_type ? props.item.water_type : '-' }}</td>
                <td>{{ props.item.param_name ? props.item.param_name : '-' }}</td>
                <td>{{ props.item.uom ? props.item.uom : '-' }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.std_val_min ? props.item.std_val_min : 0 }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.std_val_max ? props.item.std_val_max : 0 }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <v-btn
  :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
  dark fab fixed color="accent" v-if="lAction === 'view'"
  @click.native="prepareCreate">
  <v-icon>mdi-plus</v-icon>
</v-btn>

<!-- 1. Creating and updating the Water Quality-->
<v-container grid-list-md v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="saveWatQualChanges(lAction)">
        <v-card flat>
          <v-flex xs12 sm6 mx-auto>
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lAction) }} Water Quality
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                  v-model="lWaterQual.water_type"
                  label="Water Type"
                  :items="typeList"
                  item-text="water_type"
                  :rules="[rules.required]"
                  hide-details
                  ></v-select>
                  <div class="text-right">
                    <v-btn class="my-2 ml-2 mr-0" small @click="prepareWaterType">Manage Water type</v-btn>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lWaterQual.param_name"
                  label="Parameter Name"
                  hide-details
                  maxlength="10"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lWaterQual.uom"
                  label="UoM"
                  hide-details
                  maxlength="10"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lWaterQual.std_val_min"
                  label="Min"
                  hide-details
                  type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lWaterQual.std_val_max"
                  label="Max"
                  hide-details
                  type="number"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="lAction === 'update'" @click="deleteQual(lWaterQual)">delete</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click.stop="lAction = 'view'">Cancel</v-btn>
              <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- 2. manage Water type -->
<v-dialog v-model="manageWaterType" persistent max-width="400px">
  <v-form>
    <v-card flat v-if="lMAction === 'view'" scrollable>
      <v-card-title class="title grey lighten-4">
        Water Type
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="manageWaterType = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-data-table
        :headers="waterTypeHeader"
        :items="typeList"
        hide-default-footer
        :mobile-breakpoint="0"
        class="elevation-0">
        <template slot="item" slot-scope="props">
          <tr @click="prepareEdit(props.item)">
            <td>{{ props.item.water_type }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn color="accent" text @click="createWaterType()">Add New</v-btn>
    </v-card-actions>
  </v-card>

  <!-- 3. create / edit water type -->
  <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
    <v-form ref="acForm" @submit.prevent="saveWaterType(lMAction)">
      <v-card flat class="pa-0">
        <v-card-title class="title pb-0">
          {{ handy.startWithUpper(lMAction) }} Water type
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-text-field
            v-model="lWat.water_type"
            label="Water Type"
            :rules="[rules.required]"
            hide-details
            maxlength="15">
          </v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
          v-model="lWat.sort_order"
          label="Sort Order"
          :rules="[rules.required]"
          hide-details
          type="number">
        </v-text-field>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-btn text v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteWat(lWat)">delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn text @click.stop="lMAction = 'view'">Cancel</v-btn>
      <v-btn text type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-form>
</v-container>
</v-form>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="2000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      lAction: '',
      lMAction: '',
      tab: 'tab-0',
      config: config,
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      watQual: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Parameter Name', value: 'param_name' },
        { text: 'UoM', value: 'uom' },
        { text: 'Min', value: 'std_val_min' },
        { text: 'Max', value: 'std_val_max' }
      ],
      watQualsm: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Param Name', value: 'param_name' },
        { text: 'UoM', value: 'uom' }
      ],
      waterqualList: [],
      lWaterQual: [],
      typeList: [],
      manageWaterType: false,
      waterTypeHeader: [
        { text: 'Water type', value: 'water_type' }
      ],
      lWat: {}
    }
  },
  created () {
    this.loadWaterQualparam()
  },
  mounted () {
    this.lAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadWaterQualparam () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMasterWaterQualParamByVendorId/', qry)
      .then(response => {
        this.waterqualList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    prepareCreate () {
      this.lWaterQual = {
        vendor_id: config.VENDOR_ID,
        water_type_id: null,
        param_name: '',
        uom: '',
        std_val_min: null,
        std_val_max: null
      }
      this.loadWaterType()
      this.lAction = 'create'
    },
    loadWaterType () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getMasterWaterTypeByVendorId/', qry)
      .then(response => {
        this.typeList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    saveWatQualChanges (action) {
      if (this.$refs.lForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/waterQual/' + action, this.lWaterQual)
        .then(response => {
          // refresh the list
          if (action === 'create') {
            this.waterqualList.push(this.lWaterQual)
          } else {
            var idx = this.waterqualList.findIndex(watQual => watQual.water_type === this.lWaterQual.oldWatertype && watQual.param_name === this.lWaterQual.oldParam)
            Object.assign(this.waterqualList[idx], this.lWaterQual)
          }
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          console.log(err)
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    prepareUpdate (curWat) {
      this.lWaterQual = Object.assign({}, curWat)
      this.lWaterQual.oldParam = curWat.param_name
      this.lWaterQual.oldWatertype = curWat.water_type
      this.lWaterQual.std_val_min = this.lWaterQual.std_val_min ? this.lWaterQual.std_val_min : 0
      this.loadWaterType()
      this.lAction = 'update'
    },
    deleteQual (curWat) {
      if (!confirm('Sure, you want to delete the water quality with water type "' + curWat.water_type + '" and param name "' + curWat.param_name + '"')) {
        return
      }
      // up in db
      this.axios.post(config.API_URL + '/waterQual/delete', curWat)
      .then(response => {
        var idx = this.waterqualList.findIndex(watQual => watQual.water_type === this.lWaterQual.oldWatertype && watQual.param_name === this.lWaterQual.oldParam)
        this.waterqualList.splice(idx, 1)
        this.beingSaved = false
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareWaterType () {
      this.manageWaterType = true
      this.lMAction = 'view'
    },
    createWaterType () {
      this.lWat = {
        vendor_id: config.VENDOR_ID,
        water_type: '',
        sort_order: null,
      }
      this.lMAction = 'create'
    },
    prepareEdit (curWatType) {
      this.lWat = Object.assign({}, curWatType)
      this.lWat.oldWatertype = curWatType.water_type
      this.lWat.oldSortOrder = curWatType.sort_order
      this.lMAction = 'update'
    },
    saveWaterType (action) {
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/waterType/' + action, this.lWat)
        .then(response => {
          // refresh the list
          if (action === 'create') {
            this.typeList.push(this.lWat)
          } else {
            var idx = this.typeList.findIndex(watQual => watQual.water_type === this.lWat.oldWatertype)
            Object.assign(this.typeList[idx], this.lWat)
          }
          this.lMAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    deleteWat (curWat) {
      if (!confirm('Sure, you want to delete the water type "' + curWat.water_type + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/waterType/delete', curWat)
      .then(response => {
        // refresh the list
        var idx = this.typeList.findIndex(watQual => watQual.water_type === curWat.oldWatertype)
        this.typeList.splice(idx, 1)
        this.lMAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    }
  }
}
</script>
